import { render, staticRenderFns } from "./TabsWithdrawalWinnings.vue?vue&type=template&id=ae169644&scoped=true&"
import script from "./TabsWithdrawalWinnings.vue?vue&type=script&lang=js&"
export * from "./TabsWithdrawalWinnings.vue?vue&type=script&lang=js&"
import style0 from "./TabsWithdrawalWinnings.vue?vue&type=style&index=0&id=ae169644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae169644",
  null
  
)

export default component.exports